import { render, staticRenderFns } from "./TagIndexView.vue?vue&type=template&id=d2a5ba4a&scoped=true"
import script from "./TagIndexView.vue?vue&type=script&lang=js"
export * from "./TagIndexView.vue?vue&type=script&lang=js"
import style0 from "./TagIndexView.vue?vue&type=style&index=0&id=d2a5ba4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a5ba4a",
  null
  
)

export default component.exports